<template>
  <div>
    <b-container>
      <b-row class="mt-5">
        <b-col class="mt-5">
          <h3> {{ msg }}</h3>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import { ApiCalls } from '../scripts/ApiCalls'
export default {
  name: 'Callback',
  components: { },
  data () {
    return {
      custNo: [],
      state: [],
      msg: ''
    }
  },
  mounted () {
    let orderId = this.$route.query.orderid
    let merchantref = this.$route.query.merchantref
    let paymentmethod = this.$route.query.paymentmethod
    let pi = this.$route.query.pi
    console.log(localStorage.selectedCustType)
    if (localStorage.selectedCustType) {
      if (localStorage.selectedCustType === 'communal') {
        this.msg = 'Die Bestellung wurde erfolgreich durchgeführt. \r\n' +
        'Sie erhalten in den nächsten Minuten eine E-Mail mit weiterführenden Informationen.'
      } else {
        if (orderId && paymentmethod) {
          this.msg = 'Ihre Zahlung wurde erfolgreich durchgeführt. \r\n' +
            'Sobald die Zahlung bestätigt wurde, erhalten Sie eine E-Mail an die hinterlegte Adresse mit weiterführenden Informationen.'
          ApiCalls.processCallback(orderId, merchantref, paymentmethod, pi, 'SUCCESS').then(res => {
            console.log(res)
          }).catch(error => {
            console.log(error)
          })
        } else {
          this.msg = 'Ihr Beleg wurde erfolgreich erstellt und wird Ihnen in den nächsten Minuten zugestellt.\r\n' +
            'Sobald die Zahlung bestätigt wurde, erhalten Sie eine E-Mail an die hinterlegte Adresse mit weiterführenden Informationen.'
        }
      }
      localStorage.customerId = ''
      localStorage.selectedCustType = null
      localStorage.communalno = ''
      localStorage.name1 = ''
      localStorage.name2 = ''
      localStorage.contact = ''
      localStorage.street = ''
      localStorage.houseNo = ''
      localStorage.zip = ''
      localStorage.city = ''
      localStorage.mail = ''
      localStorage.fon = ''
      localStorage.useSteet = ''
      localStorage.useHouseNo = ''
      localStorage.useZip = ''
      localStorage.useCity = ''
      localStorage.connectionType = ''
      localStorage.useCase = ''
      localStorage.useUntil = ''
      localStorage.iban = ''
      localStorage.bic = ''
      localStorage.bank = ''
      localStorage.paymentMethod = null
      localStorage.contactType = ''
      localStorage.paymentContact = ''
      localStorage.paymentContactKind = ''
    } else if (orderId && paymentmethod) {
      this.msg = 'Vielen Dank, Ihre Zahlung wurde erfolgreich verarbeitet.'
      ApiCalls.processCallback(orderId, merchantref, paymentmethod, pi, 'SUCCESS').then(res => {
        console.log(res)
      }).catch(error => {
        console.log(error)
      })
    } else {
      this.msg = 'Ihr Beleg wurde erfolgreich erstellt und wird Ihnen in den nächsten Minuten zugestellt.'
    }
  },
  methods: {}
}
</script>

<style lang="css">

  .btn-evm-orange {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }
</style>
